module.exports = __webpack_public_path__ + "img/hfgc.d806ec85.png";